import { render } from "./EvolucaoDesenvolvedor.vue?vue&type=template&id=3b15195f&scoped=true"
import script from "./EvolucaoDesenvolvedor.vue?vue&type=script&lang=js"
export * from "./EvolucaoDesenvolvedor.vue?vue&type=script&lang=js"

import "./EvolucaoDesenvolvedor.vue?vue&type=style&index=0&id=3b15195f&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b15195f"]])

export default __exports__